import ScrollToTop from "../../hooks/ScrollToTop";
import PageHeader from "../../components/layout/PageHeader.jsx";
import PreviousStepContainer from "../../components/common/PreviousStepContainer";
import NextStepContainer from "../../components/common/NextStepContainer.jsx";
import SavedNotice from "../../components/common/SavedNotice";
import StakeholderManager from "../../components/impactStrategy/StakeholderManager.jsx";

/**
 * Route wrapper for Doelgroepen. The CRUD lives in <StakeholderManager> (reused
 * inline in the TOC navigator); this page adds the chrome.
 */
const Stakeholders = () => {
  ScrollToTop();

  return (
    <div className="main">
      <div className="main-container">

        <PageHeader
          heading={'Doelgroepen'}
          description={`In deze stap bepaal je wie jullie doelgroepen zijn. Dit zijn de mensen of organisaties die jullie willen bereiken met jullie impact.`}
          AI={true}
        />

        <StakeholderManager />

        <div className="impactstrategy-saved-and-nextstep-container">
          <SavedNotice />
          <div id='next-step-container'>
            <PreviousStepContainer url={'organisationcontext'} mainItem={'impactstrategy'} />
            <NextStepContainer url={'Activities'} mainItem={'impactstrategy'} />
          </div>
        </div>

      </div>
    </div>
  );
};

export default Stakeholders;
